import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { PLATFORM_SUGGESTED, PLATFORM_NEW, PLATFORM_AWAITING_CUSTOMER, PLATFORM_AWAITING_EXPERT, PLATFORM_REVIEW, PLATFORM_REVIEW_ESC, PLATFORM_QUARANTINE_TIMEOUT, PLATFORM_QUARANTINE_ESCALATED, PLATFORM_QUARANTINE_CUST, PLATFORM_QUARANTINE_ESCALATED_REVIEW, PLATFORM_QUARANTINE_NEW, PLATFORM_QUARANTINE_EXPERT, PLATFORM_QUARANTINE_EXPERT_ESC, PLATFORM_QUARANTINE_RESOLVED, PLATFORM_QUARANTINE_RESOLVED_REVIEW, PLATFORM_REPORTED, PLATFORM_ESCALATED, PLATFORM_RESOLVED, PLATFORM_TIMEOUT, PLATFORM_UNKNOWN, PLATFORM_ARCHIVED } from "../..";
const MessageState = ({
  classes,
  state,
  id
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.box} ${classes[state]}`
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "inherit",
    align: "center",
    className: classes.title,
    id: id
  }, state.replace(new RegExp("-", "g"), " ").toLowerCase()));
};
const styles = theme => ({
  box: {
    borderRadius: 4,
    padding: 4
  },
  title: {
    fontWeight: 700
  },
  [PLATFORM_SUGGESTED]: {
    color: "#fff",
    backgroundColor: theme.palette.primary.main
  },
  [PLATFORM_NEW]: {
    color: "#fff",
    backgroundColor: "#ff9800" //orange
  },
  [PLATFORM_AWAITING_CUSTOMER]: {
    color: "#fff",
    backgroundColor: theme.palette.primary.main
  },
  [PLATFORM_AWAITING_EXPERT]: {
    color: "#fff",
    backgroundColor: "#ff9800" //orange
  },
  [PLATFORM_REVIEW]: {
    color: "#fff",
    backgroundColor: theme.palette.primary.main
  },
  [PLATFORM_REVIEW_ESC]: {
    color: "#fff",
    backgroundColor: theme.palette.primary.main
  },
  [PLATFORM_QUARANTINE_NEW]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_CUST]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_EXPERT]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_EXPERT_ESC]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_TIMEOUT]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_ESCALATED]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_ESCALATED_REVIEW]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_REPORTED]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_RESOLVED]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_QUARANTINE_RESOLVED_REVIEW]: {
    color: "#fff",
    backgroundColor: theme.palette.error.main
  },
  [PLATFORM_ESCALATED]: {
    color: "#fff",
    backgroundColor: "#133149" //dark blue
  },
  [PLATFORM_RESOLVED]: {
    color: "#fff",
    backgroundColor: "#133149" //dark blue
  },
  [PLATFORM_TIMEOUT]: {
    color: "#fff",
    backgroundColor: "#757575" //grey
  },
  [PLATFORM_UNKNOWN]: {
    color: "#fff",
    backgroundColor: "#9c27b0" //purple
  },
  [PLATFORM_ARCHIVED]: {
    color: "#fff",
    backgroundColor: "#654321" //brown
  }
});
export default withStyles(styles)(MessageState);
MessageState.propTypes = {
  classes: PropTypes.object.isRequired,
  state: PropTypes.string.isRequired,
  id: PropTypes.string
};
MessageState.defaultProps = {
  id: "messageStateProperty"
};